<template>
  <div class="session">
    <TabNav :tabs="[
      { text: $t('users.sign_in'), link: '/sign_in' },
      { text: $t('users.sign_up'), link: '/sign_up' }
    ]"/>
    <slot />
  </div>
</template>
